import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { ChatbotProvider } from './context/ChatbotContext';
import MainLayout from './layouts/MainLayout';

// Lazy loaded pages
const HomePage = React.lazy(() => import('./pages/HomePage'));
const ServicesPage = React.lazy(() => import('./pages/ServicesPage'));
const PricingPage = React.lazy(() => import('./pages/PricingPage'));
const AboutPage = React.lazy(() => import('./pages/AboutPage'));
const ContactPage = React.lazy(() => import('./pages/ContactPage'));
const FaqPage = React.lazy(() => import('./pages/FaqPage'));
const BusinessCardPage = React.lazy(() => import('./pages/BusinessCardPage'));
const SuccessPage = React.lazy(() => import('./pages/SuccessPage'));
const CancelPage = React.lazy(() => import('./pages/CancelPage'));
const NotFoundPage = React.lazy(() => import('./pages/NotFoundPage'));

// Loading component
const PageLoading = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary"></div>
  </div>
);

// Language redirect component
const LanguageRedirect = () => {
  const { pathname } = useLocation();
  const userLang = localStorage.getItem('language') || navigator.language.split('-')[0];
  const targetLang = ['fr', 'en'].includes(userLang) ? userLang : 'en';
  return <Navigate to={`/${targetLang}${pathname}`} replace />;
};

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <LanguageProvider>
        <ChatbotProvider>
          <Suspense fallback={<PageLoading />}>
            <Routes>
              {/* Root redirect */}
              <Route path="/" element={<LanguageRedirect />} />
              
              {/* Language-specific routes */}
              <Route path="/:lang" element={<MainLayout />}>
                <Route index element={<HomePage />} />
                <Route path="services" element={<ServicesPage />} />
                <Route path="pricing" element={<PricingPage />} />
                <Route path="about" element={<AboutPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="faq" element={<FaqPage />} />
                <Route path="business-card" element={<BusinessCardPage />} />
                <Route path="success" element={<SuccessPage />} />
                <Route path="cancel" element={<CancelPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
          </Suspense>
        </ChatbotProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;